export default function (oEmbedUrl) {
  return {
    type: 'oembed_response',
    title: `Social`,
    icon: `share-square`,
    template: `<div contenteditable="false">
                 <div contenteditable="false" class="cover"> &nbsp;</div>
                 <iframe 
                   data-oid="{{feature._id}}"
                   style="width:100%;height:100px" 
                   ng-src="{{${oEmbedUrl}}}"
                 />
               </div>`,
    propertyTemplate: `<div contenteditable="false" class="input-group">
                         <label class="input-group-addon">Social Url: </label>
                         <input
                           class="form-control"
                           type="text"
                           ng-model="feature.referent.id"
                           placeholder="EX: https://twitter.com/" />
                       </div>`,
  }
}
